import { forwardRef } from "react";
import * as SheetPrimitive from "@radix-ui/react-dialog";

import {
  SHEET_CONTENT_CLASS,
  SHEET_ROOT_DEFAULTS,
  SHEET_SIDE_CLASS_MAP,
  SHEET_SURFACE_CLASS_MAP,
  type TSheetContentElement,
  type TSheetContentProps,
} from "@/ui/components/overlay/Sheet/Sheet.config";
import { SheetOverlay } from "@/ui/components/overlay/Sheet/SheetOverlay";
import { SheetPortal } from "@/ui/components/overlay/Sheet/SheetPortal";
import { SheetClose } from "@/ui/components/overlay/Sheet/SheetClose";
import { cn } from "@/ui/lib/utils";

export const SheetContent = forwardRef<TSheetContentElement, TSheetContentProps>(
  (
    {
      children,
      className,
      close,
      side = SHEET_ROOT_DEFAULTS.side,
      surface = SHEET_ROOT_DEFAULTS.surface,
      ...props
    },
    ref,
  ) => (
    <SheetPortal>
      <SheetOverlay />
      <SheetPrimitive.Content
        data-component="SheetContent"
        ref={ref}
        className={cn(
          SHEET_CONTENT_CLASS,
          SHEET_SIDE_CLASS_MAP[side],
          SHEET_SURFACE_CLASS_MAP[surface],
          className,
        )}
        {...props}
      >
        { children }
        { close === undefined ? <SheetClose /> : close }
      </SheetPrimitive.Content>
    </SheetPortal>
  ),
);

SheetContent.displayName = SheetPrimitive.Content.displayName;
